import { Link } from "react-router-dom";

/**
 * RC-WEB-1 §2 — OFFICIAL BRAND SLOT (single render point for the identity).
 *
 * The authoritative asset supplied by the owner lives at
 * `frontend/public/brand/avisocar-logo.png` (1448x1086, sha256 7540dec1…224b).
 * It is used EXACTLY as supplied: never redrawn, recolored, re-typeset or
 * AI-regenerated. Only whitespace-trimmed / resized derivatives are used
 * (see `frontend/scripts/derive_brand_assets.py`).
 *
 * The official lockup has a light background, so on navy/dark surfaces it is
 * placed inside a clean white brand plate instead of being altered.
 */
const OFFICIAL_ASSET_SRC = "/brand/avisocar-logo-trim.png";
const OFFICIAL_ASSET_SRCSET =
  "/brand/avisocar-logo-128.png 128w, /brand/avisocar-logo-256.png 256w, /brand/avisocar-logo-512.png 512w";

const SIZES = {
  xs: { img: "h-7", plate: "px-2 py-1 rounded-lg" },
  sm: { img: "h-10", plate: "px-2.5 py-1.5 rounded-xl" },
  md: { img: "h-12", plate: "px-3 py-2 rounded-xl" },
  lg: { img: "h-16", plate: "px-4 py-2.5 rounded-2xl" },
  xl: { img: "h-24", plate: "px-5 py-3 rounded-2xl" },
};

export const BrandMark = ({
  size = "md",
  to = "/",
  className = "",
  asLink = true,
  onDark = false,
}) => {
  const s = SIZES[size] || SIZES.md;

  const img = (
    <img
      src={OFFICIAL_ASSET_SRC}
      srcSet={OFFICIAL_ASSET_SRCSET}
      sizes="(max-width: 640px) 128px, 256px"
      alt="AvisoCar"
      className={`${s.img} w-auto object-contain`}
      data-testid="brand-mark-logo"
    />
  );

  const content = onDark ? (
    <span
      className={`inline-flex items-center bg-white shadow-sm ring-1 ring-white/40 ${s.plate}`}
      data-testid="brand-mark-plate"
    >
      {img}
    </span>
  ) : (
    img
  );

  if (!asLink) {
    return (
      <span className={`inline-flex items-center ${className}`} data-testid="brand-mark">
        {content}
      </span>
    );
  }

  return (
    <Link
      to={to}
      aria-label="AvisoCar — ir al inicio"
      className={`inline-flex items-center transition-opacity hover:opacity-90 ${className}`}
      data-testid="brand-mark"
    >
      {content}
    </Link>
  );
};

export default BrandMark;
